// ==========================================
// 1. VARIANTEN-BILDER GALERIE
// ==========================================
// Thumbnails nach Farbe filtern: jedes <li> in snippets/product-media-gallery.liquid traegt
// data-thumbnail-alt="<Alt-Text des Bildes>" (quoted + escaped). Gezeigt werden nur Thumbnails,
// deren Alt-Text dem Alt-Text des Variantenbildes entspricht. Vergleich getrimmt und
// case-insensitiv, damit z.B. "Grau (Meliert)" sauber matcht.
subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  const currentVariant = event.data.variant;
  const thumbs = document.querySelectorAll('[data-thumbnail-alt]');
  const currentImgAlt = currentVariant && currentVariant.featured_image && currentVariant.featured_image.alt
    ? currentVariant.featured_image.alt.trim().toLowerCase()
    : '';
  thumbs.forEach((thumb) => {
    if (!currentImgAlt) {
      thumb.style.display = '';
      return;
    }
    const altValue = (thumb.dataset.thumbnailAlt || '').trim().toLowerCase();
    thumb.style.display = altValue === currentImgAlt ? '' : 'none';
  });
});

// ==========================================
// 2. FILTER PERMANENT OFFEN HALTEN
// ==========================================
function forceOpenFilters() {
  document.querySelectorAll('details.facets__disclosure').forEach(detail => {
    detail.setAttribute('open', 'true');
  });
}
forceOpenFilters();

// ==========================================
// 3. RADIO-BUTTON & X-BUTTON LOGIK (ROTOR + FORCE-SHOW)
// ==========================================
// Fängt Klicks auf das X ab und nutzt es als mechanischen Ladeindikator
document.addEventListener('click', function(e) {
    const clearBtn = e.target.closest('.custom-clear-btn');
    if (clearBtn) {
        e.preventDefault();
        
        // 1. Zünde den Motor für die Drehung
        clearBtn.classList.add('is-spinning');
        
        // 2. Zwinge das X, sichtbar zu bleiben (Überbrückung des CSS)
        const wrapper = clearBtn.closest('.custom-clear-btn-wrapper');
        if (wrapper) wrapper.classList.add('force-show');
        
        const list = clearBtn.closest('ul.facets__list');
        if (!list) return;
        
        // 3. Simuliere den Klick auf den aktiven Filter, um Shopify zum Laden zu zwingen
        const activeCheckbox = list.querySelector('input[type="checkbox"]:checked');
        if (activeCheckbox) {
            const label = activeCheckbox.closest('label');
            if (label) {
                label.click(); 
            } else {
                activeCheckbox.click(); 
            }
        }
    }
});

// Fängt Filter-Klicks (Auto/Motorrad) ab und startet die Drehung
document.addEventListener('change', function(e) {
    if (e.target.matches('.facets__disclosure ul.facets__list input[type="checkbox"]')) {
        const list = e.target.closest('ul.facets__list');
        const checkboxes = list.querySelectorAll('input[type="checkbox"]');
        const clearBtn = list.querySelector('.custom-clear-btn');
        
        // Wenn ein neuer Filter angeklickt wird, startet das X sofort die Drehung
        if (clearBtn) clearBtn.classList.add('is-spinning');
        
        // Entweder-Oder Logik durchsetzen
        if (e.target.checked) {
            checkboxes.forEach(cb => {
                if (cb !== e.target && cb.checked) {
                    cb.checked = false;
                }
            });
        }
    }
});

// ==========================================
// 4. HAUPT-OBSERVER
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
  const filterContainer = document.getElementById('FacetFiltersForm') || document.querySelector('.facets-container');
  if (filterContainer) {
    new MutationObserver(() => {
        forceOpenFilters();
    }).observe(filterContainer, { childList: true, subtree: true });
  }
});